import { CardMenu } from './types';

const staticItems: Array<Record<string, string | JSX.Element>> = [
    {
        name: 'today_count',
        label: 'تعداد تراکنش‌های موفق امروز',
        value_prefix: 'عدد',
        icon: <i className="fa-light fa-money-bill-trend-up"></i>,
    },
    {
        name: 'yesterday_count',
        label: 'تعداد تراکنش‌های موفق دیروز',
        value_prefix: 'عدد',
        icon: <i className="fa-light fa-money-bill-trend-up"></i>,
    },
    {
        name: 'today_amount',
        label: 'مجموع کل درآمد امروز',
        value_prefix: 'ریال',
        icon: <i className="fa-light fa-money-bills"></i>,
    },
    {
        name: 'yesterday_amount',
        label: 'مجموع کل درآمد دیروز',
        value_prefix: 'ریال',
        icon: <i className="fa-light fa-money-bills"></i>,
    },
];

const pendingMenus: CardMenu[] = [
    {
        route: 'overall',
        label: 'تنظیمات کلی',
        icon: <i className="fa-light fa-gear"></i>,
    },
    {
        route: '',
        label: 'حذف درخواست',
        icon: <i className="fa-light fa-trash-can"></i>,
    },
];

const rejectedMenus: CardMenu[] = [
    {
        route: '',
        label: 'حذف درخواست',
        icon: <i className="fa-light fa-trash-can"></i>,
    },
];

const activeMenus = ({
    overall,
    personal,
    namad,
    notifications,
    admins,
    terminals,
    contract,
}: {
    overall?: boolean;
    personal?: boolean;
    namad?: boolean;
    notifications?: boolean;
    admins?: boolean;
    terminals?: boolean;
    contract?: boolean;
}): CardMenu[] => {
    const menuItems: CardMenu[] = [];

    overall &&
        menuItems.push({
            route: 'overall',
            label: 'تنظیمات کلی',
            icon: <i className="fa-light fa-gear"></i>,
        });

    namad &&
        menuItems.push({
            route: 'namad',
            label: 'نماد اعتماد درگاه پرداخت',
            icon: <i className="fa-light fa-shield-alt"></i>,
        });

    notifications &&
        menuItems.push({
            route: 'notifications',
            label: 'تنظیمات اطلاع‌رسانی',
            icon: <i className="fa-light fa-bell"></i>,
        });

    admins &&
        menuItems.push({
            route: 'admins',
            label: 'سطح دسترسی‌ها',
            icon: <i className="fa-light fa-user-tie"></i>,
        });

    terminals &&
        menuItems.push({
            route: 'terminals',
            label: 'جزئیات پایانه‌ها',
            icon: <i className="fa-light fa-list-check"></i>,
        });

    contract &&
        menuItems.push({
            route: 'contract',
            label: 'قرارداد ارائه خدمات',
            icon: <i className="fa-light fa-file-contract"></i>,
        });

    return menuItems;
};

export { pendingMenus, rejectedMenus, activeMenus, staticItems };
